import Vue from 'vue';
import development from '@/helpers/config/development';
import production from '@/helpers/config/production';
require('dotenv').config(); 
 
let config = null;

if(process.env.VUE_APP_MODE === 'dev') {
    config = development;
} else {
    config = production;
};
   
const key = '$config';
Object.defineProperty(Vue.prototype, key, {
    get() {
        return Object.freeze(config);
    }
});
